import React from "react";
import Classnames from "classnames";

const LoginForm = ({
  onChange,
  onSubmit,
  username,
  password,
  loading,
  loginFailed
}) => {
  const btnClass = Classnames("btn", "btn-info", { disabled: loading });
  const btnIcon = Classnames(
    "fa",
    { "fa-sign-in": !loading },
    { "fa-spinner fa-spin": loading }
  );
  const warningClass = Classnames("alert", "alert-warning", {
    invisible: !loginFailed
  });

  return (
    <div className="container">
      <form className="form-signin" onSubmit={onSubmit}>
        <h2 className="form-signin-heading">Please Log In</h2>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            name="username"
            id="username"
            className="form-control"
            value={username}
            onChange={onChange}
            autoFocus
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            className="form-control"
            value={password}
            onChange={onChange}
          />
        </div>
        <div className="text-center">
          <p>
            <button type="submit" className={btnClass}>
              <i className={btnIcon} /> Sign In
            </button>
          </p>

          <p className={warningClass}>
            <strong>
              <i className="fa fa-exclamation-triangle" />
            </strong>
            Your email or password was incorrect
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/pages/Login/Form.jsx